import { __module as reactResponsive$1 } from '../../../_virtual/react-responsive2.js';
import React__default from 'react';

var reactResponsive = reactResponsive$1.exports;

var hasRequiredReactResponsive;

function requireReactResponsive () {
	if (hasRequiredReactResponsive) return reactResponsive$1.exports;
	hasRequiredReactResponsive = 1;
	(function (module, exports) {
		!function(root, factory) {
		    module.exports = factory(React__default) ;
		}("undefined" != typeof self ? self : reactResponsive, function(__WEBPACK_EXTERNAL_MODULE_8__) {
		    return function(modules) {
		        function __webpack_require__(moduleId) {
		            if (installedModules[moduleId]) return installedModules[moduleId].exports;
		            var module = installedModules[moduleId] = {
		                i: moduleId,
		                l: false,
		                exports: {}
		            };
		            return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), 
		            module.l = true, module.exports;
		        }
		        var installedModules = {};
		        return __webpack_require__.m = modules, __webpack_require__.c = installedModules, 
		        __webpack_require__.d = function(exports, name, getter) {
		            __webpack_require__.o(exports, name) || Object.defineProperty(exports, name, {
		                configurable: false,
		                enumerable: true,
		                get: getter
		            });
		        }, __webpack_require__.n = function(module) {
		            var getter = module && module.__esModule ? function() {
		                return module.default;
		            } : function() {
		                return module;
		            };
		            return __webpack_require__.d(getter, "a", getter), getter;
		        }, __webpack_require__.o = function(object, property) {
		            return Object.prototype.hasOwnProperty.call(object, property);
		        }, __webpack_require__.p = "", __webpack_require__(__webpack_require__.s = 7);
		    }([ function(module, exports, __webpack_require__) {
		        var REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103, isValidElement = function(object) {
		            return "object" == typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
		        };
		        module.exports = __webpack_require__(9)(isValidElement, true);
		    }, function(module, exports, __webpack_require__) {
		        function makeEmptyFunction(arg) {
		            return function() {
		                return arg;
		            };
		        }
		        var emptyFunction = function() {};
		        emptyFunction.thatReturns = makeEmptyFunction, emptyFunction.thatReturnsFalse = makeEmptyFunction(false), 
		        emptyFunction.thatReturnsTrue = makeEmptyFunction(true), emptyFunction.thatReturnsNull = makeEmptyFunction(null), 
		        emptyFunction.thatReturnsThis = function() {
		            return this;
		        }, emptyFunction.thatReturnsArgument = function(arg) {
		            return arg;
		        }, module.exports = emptyFunction;
		    }, function(module, exports, __webpack_require__) {
		        function invariant(condition, format, a, b, c, d, e, f) {
		            if (validateFormat(format), !condition) {
		                var error;
		                if (void 0 === format) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings."); else {
		                    var args = [ a, b, c, d, e, f ], argIndex = 0;
		                    error = new Error(format.replace(/%s/g, function() {
		                        return args[argIndex++];
		                    })), error.name = "Invariant Violation";
		                }
		                throw error.framesToPop = 1, error;
		            }
		        }
		        var validateFormat = function(format) {};
		        validateFormat = function(format) {
		            if (void 0 === format) throw new Error("invariant requires an error message argument");
		        }, module.exports = invariant;
		    }, function(module, exports, __webpack_require__) {
		        var emptyFunction = __webpack_require__(1), warning = emptyFunction, printWarning = function(format) {
		            for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) args[_key - 1] = arguments[_key];
		            var argIndex = 0, message = "Warning: " + format.replace(/%s/g, function() {
		                return args[argIndex++];
		            });
		            "undefined" != typeof console && console.error(message);
		            try {
		                throw new Error(message);
		            } catch (x) {}
		        };
		        warning = function(condition, format) {
		            if (void 0 === format) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
		            if (0 !== format.indexOf("Failed Composite propType: ") && !condition) {
		                for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) args[_key2 - 2] = arguments[_key2];
		                printWarning.apply(void 0, [ format ].concat(args));
		            }
		        }, module.exports = warning;
		    }, function(module, exports, __webpack_require__) {
		        module.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
		    }, function(module, exports, __webpack_require__) {
		        function hyphenateStyleName(string) {
		            return string in cache ? cache[string] : cache[string] = string.replace(uppercasePattern, "-$&").toLowerCase().replace(msPattern, "-ms-");
		        }
		        var uppercasePattern = /[A-Z]/g, msPattern = /^ms-/, cache = {};
		        module.exports = hyphenateStyleName;
		    }, function(module, exports, __webpack_require__) {
		        Object.defineProperty(exports, "__esModule", {
		            value: true
		        });
		        var _extends = Object.assign || function(target) {
		            for (var i = 1; i < arguments.length; i++) {
		                var source = arguments[i];
		                for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
		            }
		            return target;
		        }, _propTypes = __webpack_require__(0), _propTypes2 = function(obj) {
		            return obj && obj.__esModule ? obj : {
		                default: obj
		            };
		        }(_propTypes), stringOrNumber = _propTypes2.default.oneOfType([ _propTypes2.default.string, _propTypes2.default.number ]), matchers = {
		            orientation: _propTypes2.default.oneOf([ "portrait", "landscape" ]),
		            scan: _propTypes2.default.oneOf([ "progressive", "interlace" ]),
		            aspectRatio: _propTypes2.default.string,
		            deviceAspectRatio: _propTypes2.default.string,
		            height: stringOrNumber,
		            deviceHeight: stringOrNumber,
		            width: stringOrNumber,
		            deviceWidth: stringOrNumber,
		            color: _propTypes2.default.bool,
		            colorIndex: _propTypes2.default.bool,
		            monochrome: _propTypes2.default.bool,
		            resolution: stringOrNumber
		        }, features = _extends({
		            minAspectRatio: _propTypes2.default.string,
		            maxAspectRatio: _propTypes2.default.string,
		            minDeviceAspectRatio: _propTypes2.default.string,
		            maxDeviceAspectRatio: _propTypes2.default.string,
		            minHeight: stringOrNumber,
		            maxHeight: stringOrNumber,
		            minDeviceHeight: stringOrNumber,
		            maxDeviceHeight: stringOrNumber,
		            minWidth: stringOrNumber,
		            maxWidth: stringOrNumber,
		            minDeviceWidth: stringOrNumber,
		            maxDeviceWidth: stringOrNumber,
		            minColor: _propTypes2.default.number,
		            maxColor: _propTypes2.default.number,
		            minColorIndex: _propTypes2.default.number,
		            maxColorIndex: _propTypes2.default.number,
		            minMonochrome: _propTypes2.default.number,
		            maxMonochrome: _propTypes2.default.number,
		            minResolution: stringOrNumber,
		            maxResolution: stringOrNumber
		        }, matchers), types = {
		            all: _propTypes2.default.bool,
		            grid: _propTypes2.default.bool,
		            aural: _propTypes2.default.bool,
		            braille: _propTypes2.default.bool,
		            handheld: _propTypes2.default.bool,
		            print: _propTypes2.default.bool,
		            projection: _propTypes2.default.bool,
		            screen: _propTypes2.default.bool,
		            tty: _propTypes2.default.bool,
		            tv: _propTypes2.default.bool,
		            embossed: _propTypes2.default.bool
		        }, all = _extends({}, types, features);
		        matchers.type = Object.keys(types), exports.default = {
		            all: all,
		            types: types,
		            matchers: matchers,
		            features: features
		        }, module.exports = exports.default;
		    }, function(module, exports, __webpack_require__) {
		        function _interopRequireDefault(obj) {
		            return obj && obj.__esModule ? obj : {
		                default: obj
		            };
		        }
		        function _classCallCheck(instance, Constructor) {
		            if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
		        }
		        function _possibleConstructorReturn(self, call) {
		            if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		            return !call || "object" != typeof call && "function" != typeof call ? self : call;
		        }
		        function _inherits(subClass, superClass) {
		            if ("function" != typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
		            subClass.prototype = Object.create(superClass && superClass.prototype, {
		                constructor: {
		                    value: subClass,
		                    enumerable: false,
		                    writable: true,
		                    configurable: true
		                }
		            }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
		        }
		        function omit(object, keys) {
		            var newObject = _extends({}, object);
		            return keys.forEach(function(key) {
		                return delete newObject[key];
		            }), newObject;
		        }
		        Object.defineProperty(exports, "__esModule", {
		            value: true
		        }), exports.toQuery = exports.default = void 0;
		        var _createClass = function() {
		            function defineProperties(target, props) {
		                for (var i = 0; i < props.length; i++) {
		                    var descriptor = props[i];
		                    descriptor.enumerable = descriptor.enumerable || false, descriptor.configurable = true, 
		                    "value" in descriptor && (descriptor.writable = true), Object.defineProperty(target, descriptor.key, descriptor);
		                }
		            }
		            return function(Constructor, protoProps, staticProps) {
		                return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), 
		                Constructor;
		            };
		        }(), _extends = Object.assign || function(target) {
		            for (var i = 1; i < arguments.length; i++) {
		                var source = arguments[i];
		                for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
		            }
		            return target;
		        }, _react = __webpack_require__(8), _react2 = _interopRequireDefault(_react), _propTypes = __webpack_require__(0), _propTypes2 = _interopRequireDefault(_propTypes), _matchmediaquery = __webpack_require__(12), _matchmediaquery2 = _interopRequireDefault(_matchmediaquery), _hyphenateStyleName = __webpack_require__(5), _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName), _mediaQuery = __webpack_require__(6), _mediaQuery2 = _interopRequireDefault(_mediaQuery), _toQuery = __webpack_require__(14), _toQuery2 = _interopRequireDefault(_toQuery), defaultTypes = {
		            component: _propTypes2.default.node,
		            query: _propTypes2.default.string,
		            values: _propTypes2.default.shape(_mediaQuery2.default.matchers),
		            children: _propTypes2.default.oneOfType([ _propTypes2.default.node, _propTypes2.default.func ]),
		            onChange: _propTypes2.default.func,
		            onBeforeChange: _propTypes2.default.func
		        }, mediaKeys = Object.keys(_mediaQuery2.default.all), excludedQueryKeys = Object.keys(defaultTypes), excludedPropKeys = excludedQueryKeys.concat(mediaKeys), MediaQuery = function(_React$Component) {
		            function MediaQuery() {
		                var _ref, _temp, _this, _ret;
		                _classCallCheck(this, MediaQuery);
		                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
		                return _temp = _this = _possibleConstructorReturn(this, (_ref = MediaQuery.__proto__ || Object.getPrototypeOf(MediaQuery)).call.apply(_ref, [ this ].concat(args))), 
		                _this.state = {
		                    matches: false
		                }, _this.updateMatches = function() {
		                    _this._mql.matches !== _this.state.matches && _this.setState({
		                        matches: _this._mql.matches
		                    });
		                }, _this.removeMql = function() {
		                    _this._mql && (_this._mql.removeListener(_this.updateMatches), _this._mql.dispose());
		                }, _ret = _temp, _possibleConstructorReturn(_this, _ret);
		            }
		            return _inherits(MediaQuery, _React$Component), _createClass(MediaQuery, [ {
		                key: "componentWillMount",
		                value: function() {
		                    this.updateQuery(this.props);
		                }
		            }, {
		                key: "componentWillReceiveProps",
		                value: function(nextProps) {
		                    this.updateQuery(nextProps);
		                }
		            }, {
		                key: "updateQuery",
		                value: function(props) {
		                    var values = void 0;
		                    if (props.query ? this.query = props.query : this.query = (0, _toQuery2.default)(omit(props, excludedQueryKeys)), 
		                    !this.query) throw new Error("Invalid or missing MediaQuery!");
		                    props.values && (values = Object.keys(props.values).reduce(function(result, key) {
		                        return result[(0, _hyphenateStyleName2.default)(key)] = props.values[key], result;
		                    }, {})), this.removeMql(), this._mql = (0, _matchmediaquery2.default)(this.query, values), 
		                    this._mql.addListener(this.updateMatches), this.updateMatches();
		                }
		            }, {
		                key: "componentWillUpdate",
		                value: function(_, nextState) {
		                    this.props.onBeforeChange && this.state.matches !== nextState.matches && this.props.onBeforeChange(this.state.matches);
		                }
		            }, {
		                key: "componentDidUpdate",
		                value: function(_, prevState) {
		                    this.props.onChange && prevState.matches !== this.state.matches && this.props.onChange(this.state.matches);
		                }
		            }, {
		                key: "componentWillUnmount",
		                value: function() {
		                    this.removeMql();
		                }
		            }, {
		                key: "render",
		                value: function() {
		                    if ("function" == typeof this.props.children) return this.props.children(this.state.matches);
		                    if (false === this.state.matches) return null;
		                    var props = omit(this.props, excludedPropKeys), hasMergeProps = Object.keys(props).length > 0, childrenCount = _react2.default.Children.count(this.props.children);
		                    return this.props.component || null == this.props.children || hasMergeProps && childrenCount > 1 ? _react2.default.createElement(this.props.component || "div", props, this.props.children) : hasMergeProps ? _react2.default.cloneElement(this.props.children, props) : childrenCount ? this.props.children : null;
		                }
		            } ]), MediaQuery;
		        }(_react2.default.Component);
		        MediaQuery.displayName = "MediaQuery", MediaQuery.defaultProps = {
		            values: {}
		        }, exports.default = MediaQuery, exports.toQuery = _toQuery2.default;
		    }, function(module, exports) {
		        module.exports = __WEBPACK_EXTERNAL_MODULE_8__;
		    }, function(module, exports, __webpack_require__) {
		        var emptyFunction = __webpack_require__(1), invariant = __webpack_require__(2), warning = __webpack_require__(3), assign = __webpack_require__(10), ReactPropTypesSecret = __webpack_require__(4), checkPropTypes = __webpack_require__(11);
		        module.exports = function(isValidElement, throwOnDirectAccess) {
		            function getIteratorFn(maybeIterable) {
		                var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
		                if ("function" == typeof iteratorFn) return iteratorFn;
		            }
		            function is(x, y) {
		                return x === y ? 0 !== x || 1 / x == 1 / y : x !== x && y !== y;
		            }
		            function PropTypeError(message) {
		                this.message = message, this.stack = "";
		            }
		            function createChainableTypeChecker(validate) {
		                function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
		                    if (componentName = componentName || ANONYMOUS, propFullName = propFullName || propName, 
		                    secret !== ReactPropTypesSecret) if (throwOnDirectAccess) invariant(false, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"); else if ("undefined" != typeof console) {
		                        var cacheKey = componentName + ":" + propName;
		                        !manualPropTypeCallCache[cacheKey] && manualPropTypeWarningCount < 3 && (warning(false, "You are manually calling a React.PropTypes validation function for the `%s` prop on `%s`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details.", propFullName, componentName), 
		                        manualPropTypeCallCache[cacheKey] = true, manualPropTypeWarningCount++);
		                    }
		                    return null == props[propName] ? isRequired ? new PropTypeError(null === props[propName] ? "The " + location + " `" + propFullName + "` is marked as required in `" + componentName + "`, but its value is `null`." : "The " + location + " `" + propFullName + "` is marked as required in `" + componentName + "`, but its value is `undefined`.") : null : validate(props, propName, componentName, location, propFullName);
		                }
		                var manualPropTypeCallCache = {}, manualPropTypeWarningCount = 0, chainedCheckType = checkType.bind(null, false);
		                return chainedCheckType.isRequired = checkType.bind(null, true), chainedCheckType;
		            }
		            function createPrimitiveTypeChecker(expectedType) {
		                function validate(props, propName, componentName, location, propFullName, secret) {
		                    var propValue = props[propName];
		                    if (getPropType(propValue) !== expectedType) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getPreciseType(propValue) + "` supplied to `" + componentName + "`, expected `" + expectedType + "`.");
		                    return null;
		                }
		                return createChainableTypeChecker(validate);
		            }
		            function createArrayOfTypeChecker(typeChecker) {
		                function validate(props, propName, componentName, location, propFullName) {
		                    if ("function" != typeof typeChecker) return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
		                    var propValue = props[propName];
		                    if (!Array.isArray(propValue)) {
		                        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getPropType(propValue) + "` supplied to `" + componentName + "`, expected an array.");
		                    }
		                    for (var i = 0; i < propValue.length; i++) {
		                        var error = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", ReactPropTypesSecret);
		                        if (error instanceof Error) return error;
		                    }
		                    return null;
		                }
		                return createChainableTypeChecker(validate);
		            }
		            function createInstanceTypeChecker(expectedClass) {
		                function validate(props, propName, componentName, location, propFullName) {
		                    if (!(props[propName] instanceof expectedClass)) {
		                        var expectedClassName = expectedClass.name || ANONYMOUS;
		                        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getClassName(props[propName]) + "` supplied to `" + componentName + "`, expected instance of `" + expectedClassName + "`.");
		                    }
		                    return null;
		                }
		                return createChainableTypeChecker(validate);
		            }
		            function createEnumTypeChecker(expectedValues) {
		                function validate(props, propName, componentName, location, propFullName) {
		                    for (var propValue = props[propName], i = 0; i < expectedValues.length; i++) if (is(propValue, expectedValues[i])) return null;
		                    return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + propValue + "` supplied to `" + componentName + "`, expected one of " + JSON.stringify(expectedValues) + ".");
		                }
		                return Array.isArray(expectedValues) ? createChainableTypeChecker(validate) : (warning(false, "Invalid argument supplied to oneOf, expected an instance of array."), 
		                emptyFunction.thatReturnsNull);
		            }
		            function createObjectOfTypeChecker(typeChecker) {
		                function validate(props, propName, componentName, location, propFullName) {
		                    if ("function" != typeof typeChecker) return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
		                    var propValue = props[propName], propType = getPropType(propValue);
		                    if ("object" !== propType) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` supplied to `" + componentName + "`, expected an object.");
		                    for (var key in propValue) if (propValue.hasOwnProperty(key)) {
		                        var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
		                        if (error instanceof Error) return error;
		                    }
		                    return null;
		                }
		                return createChainableTypeChecker(validate);
		            }
		            function createUnionTypeChecker(arrayOfTypeCheckers) {
		                function validate(props, propName, componentName, location, propFullName) {
		                    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
		                        if (null == (0, arrayOfTypeCheckers[i])(props, propName, componentName, location, propFullName, ReactPropTypesSecret)) return null;
		                    }
		                    return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to `" + componentName + "`.");
		                }
		                if (!Array.isArray(arrayOfTypeCheckers)) return warning(false, "Invalid argument supplied to oneOfType, expected an instance of array."), 
		                emptyFunction.thatReturnsNull;
		                for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
		                    var checker = arrayOfTypeCheckers[i];
		                    if ("function" != typeof checker) return warning(false, "Invalid argument supplied to oneOfType. Expected an array of check functions, but received %s at index %s.", getPostfixForTypeWarning(checker), i), 
		                    emptyFunction.thatReturnsNull;
		                }
		                return createChainableTypeChecker(validate);
		            }
		            function createShapeTypeChecker(shapeTypes) {
		                function validate(props, propName, componentName, location, propFullName) {
		                    var propValue = props[propName], propType = getPropType(propValue);
		                    if ("object" !== propType) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` supplied to `" + componentName + "`, expected `object`.");
		                    for (var key in shapeTypes) {
		                        var checker = shapeTypes[key];
		                        if (checker) {
		                            var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
		                            if (error) return error;
		                        }
		                    }
		                    return null;
		                }
		                return createChainableTypeChecker(validate);
		            }
		            function createStrictShapeTypeChecker(shapeTypes) {
		                function validate(props, propName, componentName, location, propFullName) {
		                    var propValue = props[propName], propType = getPropType(propValue);
		                    if ("object" !== propType) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` supplied to `" + componentName + "`, expected `object`.");
		                    var allKeys = assign({}, props[propName], shapeTypes);
		                    for (var key in allKeys) {
		                        var checker = shapeTypes[key];
		                        if (!checker) return new PropTypeError("Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  "));
		                        var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
		                        if (error) return error;
		                    }
		                    return null;
		                }
		                return createChainableTypeChecker(validate);
		            }
		            function isNode(propValue) {
		                switch (typeof propValue) {
		                  case "number":
		                  case "string":
		                  case "undefined":
		                    return true;

		                  case "boolean":
		                    return !propValue;

		                  case "object":
		                    if (Array.isArray(propValue)) return propValue.every(isNode);
		                    if (null === propValue || isValidElement(propValue)) return true;
		                    var iteratorFn = getIteratorFn(propValue);
		                    if (!iteratorFn) return false;
		                    var step, iterator = iteratorFn.call(propValue);
		                    if (iteratorFn !== propValue.entries) {
		                        for (;!(step = iterator.next()).done; ) if (!isNode(step.value)) return false;
		                    } else for (;!(step = iterator.next()).done; ) {
		                        var entry = step.value;
		                        if (entry && !isNode(entry[1])) return false;
		                    }
		                    return true;

		                  default:
		                    return false;
		                }
		            }
		            function isSymbol(propType, propValue) {
		                return "symbol" === propType || ("Symbol" === propValue["@@toStringTag"] || "function" == typeof Symbol && propValue instanceof Symbol);
		            }
		            function getPropType(propValue) {
		                var propType = typeof propValue;
		                return Array.isArray(propValue) ? "array" : propValue instanceof RegExp ? "object" : isSymbol(propType, propValue) ? "symbol" : propType;
		            }
		            function getPreciseType(propValue) {
		                if (void 0 === propValue || null === propValue) return "" + propValue;
		                var propType = getPropType(propValue);
		                if ("object" === propType) {
		                    if (propValue instanceof Date) return "date";
		                    if (propValue instanceof RegExp) return "regexp";
		                }
		                return propType;
		            }
		            function getPostfixForTypeWarning(value) {
		                var type = getPreciseType(value);
		                switch (type) {
		                  case "array":
		                  case "object":
		                    return "an " + type;

		                  case "boolean":
		                  case "date":
		                  case "regexp":
		                    return "a " + type;

		                  default:
		                    return type;
		                }
		            }
		            function getClassName(propValue) {
		                return propValue.constructor && propValue.constructor.name ? propValue.constructor.name : ANONYMOUS;
		            }
		            var ITERATOR_SYMBOL = "function" == typeof Symbol && Symbol.iterator, FAUX_ITERATOR_SYMBOL = "@@iterator", ANONYMOUS = "<<anonymous>>", ReactPropTypes = {
		                array: createPrimitiveTypeChecker("array"),
		                bool: createPrimitiveTypeChecker("boolean"),
		                func: createPrimitiveTypeChecker("function"),
		                number: createPrimitiveTypeChecker("number"),
		                object: createPrimitiveTypeChecker("object"),
		                string: createPrimitiveTypeChecker("string"),
		                symbol: createPrimitiveTypeChecker("symbol"),
		                any: function() {
		                    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
		                }(),
		                arrayOf: createArrayOfTypeChecker,
		                element: function() {
		                    function validate(props, propName, componentName, location, propFullName) {
		                        var propValue = props[propName];
		                        if (!isValidElement(propValue)) {
		                            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getPropType(propValue) + "` supplied to `" + componentName + "`, expected a single ReactElement.");
		                        }
		                        return null;
		                    }
		                    return createChainableTypeChecker(validate);
		                }(),
		                instanceOf: createInstanceTypeChecker,
		                node: function() {
		                    function validate(props, propName, componentName, location, propFullName) {
		                        return isNode(props[propName]) ? null : new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to `" + componentName + "`, expected a ReactNode.");
		                    }
		                    return createChainableTypeChecker(validate);
		                }(),
		                objectOf: createObjectOfTypeChecker,
		                oneOf: createEnumTypeChecker,
		                oneOfType: createUnionTypeChecker,
		                shape: createShapeTypeChecker,
		                exact: createStrictShapeTypeChecker
		            };
		            return PropTypeError.prototype = Error.prototype, ReactPropTypes.checkPropTypes = checkPropTypes, 
		            ReactPropTypes.PropTypes = ReactPropTypes, ReactPropTypes;
		        };
		    }, function(module, exports, __webpack_require__) {
		        function toObject(val) {
		            if (null === val || void 0 === val) throw new TypeError("Object.assign cannot be called with null or undefined");
		            return Object(val);
		        }
		        /*
		object-assign
		(c) Sindre Sorhus
		@license MIT
		*/
		        var getOwnPropertySymbols = Object.getOwnPropertySymbols, hasOwnProperty = Object.prototype.hasOwnProperty, propIsEnumerable = Object.prototype.propertyIsEnumerable;
		        module.exports = function() {
		            try {
		                if (!Object.assign) return !1;
		                var test1 = new String("abc");
		                if (test1[5] = "de", "5" === Object.getOwnPropertyNames(test1)[0]) return !1;
		                for (var test2 = {}, i = 0; i < 10; i++) test2["_" + String.fromCharCode(i)] = i;
		                if ("0123456789" !== Object.getOwnPropertyNames(test2).map(function(n) {
		                    return test2[n];
		                }).join("")) return !1;
		                var test3 = {};
		                return "abcdefghijklmnopqrst".split("").forEach(function(letter) {
		                    test3[letter] = letter;
		                }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, test3)).join("");
		            } catch (err) {
		                return false;
		            }
		        }() ? Object.assign : function(target, source) {
		            for (var from, symbols, to = toObject(target), s = 1; s < arguments.length; s++) {
		                from = Object(arguments[s]);
		                for (var key in from) hasOwnProperty.call(from, key) && (to[key] = from[key]);
		                if (getOwnPropertySymbols) {
		                    symbols = getOwnPropertySymbols(from);
		                    for (var i = 0; i < symbols.length; i++) propIsEnumerable.call(from, symbols[i]) && (to[symbols[i]] = from[symbols[i]]);
		                }
		            }
		            return to;
		        };
		    }, function(module, exports, __webpack_require__) {
		        function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
		            for (var typeSpecName in typeSpecs) if (typeSpecs.hasOwnProperty(typeSpecName)) {
		                var error;
		                try {
		                    invariant("function" == typeof typeSpecs[typeSpecName], "%s: %s type `%s` is invalid; it must be a function, usually from the `prop-types` package, but received `%s`.", componentName || "React class", location, typeSpecName, typeof typeSpecs[typeSpecName]), 
		                    error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
		                } catch (ex) {
		                    error = ex;
		                }
		                if (warning(!error || error instanceof Error, "%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error), 
		                error instanceof Error && !(error.message in loggedTypeFailures)) {
		                    loggedTypeFailures[error.message] = true;
		                    var stack = getStack ? getStack() : "";
		                    warning(false, "Failed %s type: %s%s", location, error.message, null != stack ? stack : "");
		                }
		            }
		        }
		        var invariant = __webpack_require__(2), warning = __webpack_require__(3), ReactPropTypesSecret = __webpack_require__(4), loggedTypeFailures = {};
		        module.exports = checkPropTypes;
		    }, function(module, exports, __webpack_require__) {
		        function Mql(query, values) {
		            function addListener(listener) {
		                mql && mql.addListener(listener);
		            }
		            function removeListener(listener) {
		                mql && mql.removeListener(listener);
		            }
		            function update(evt) {
		                self.matches = evt.matches, self.media = evt.media;
		            }
		            function dispose() {
		                mql && mql.removeListener(update);
		            }
		            var self = this;
		            if (dynamicMatch) {
		                var mql = dynamicMatch.call(window, query);
		                this.matches = mql.matches, this.media = mql.media, mql.addListener(update);
		            } else this.matches = staticMatch(query, values), this.media = query;
		            this.addListener = addListener, this.removeListener = removeListener, this.dispose = dispose;
		        }
		        function matchMedia(query, values) {
		            return new Mql(query, values);
		        }
		        var staticMatch = __webpack_require__(13).match, dynamicMatch = "undefined" != typeof window ? window.matchMedia : null;
		        module.exports = matchMedia;
		    }, function(module, exports, __webpack_require__) {
		        function matchQuery(mediaQuery, values) {
		            return parseQuery(mediaQuery).some(function(query) {
		                var inverse = query.inverse, typeMatch = "all" === query.type || values.type === query.type;
		                if (typeMatch && inverse || !typeMatch && !inverse) return false;
		                var expressionsMatch = query.expressions.every(function(expression) {
		                    var feature = expression.feature, modifier = expression.modifier, expValue = expression.value, value = values[feature];
		                    if (!value) return false;
		                    switch (feature) {
		                      case "orientation":
		                      case "scan":
		                        return value.toLowerCase() === expValue.toLowerCase();

		                      case "width":
		                      case "height":
		                      case "device-width":
		                      case "device-height":
		                        expValue = toPx(expValue), value = toPx(value);
		                        break;

		                      case "resolution":
		                        expValue = toDpi(expValue), value = toDpi(value);
		                        break;

		                      case "aspect-ratio":
		                      case "device-aspect-ratio":
		                      case "device-pixel-ratio":
		                        expValue = toDecimal(expValue), value = toDecimal(value);
		                        break;

		                      case "grid":
		                      case "color":
		                      case "color-index":
		                      case "monochrome":
		                        expValue = parseInt(expValue, 10) || 1, value = parseInt(value, 10) || 0;
		                    }
		                    switch (modifier) {
		                      case "min":
		                        return value >= expValue;

		                      case "max":
		                        return value <= expValue;

		                      default:
		                        return value === expValue;
		                    }
		                });
		                return expressionsMatch && !inverse || !expressionsMatch && inverse;
		            });
		        }
		        function parseQuery(mediaQuery) {
		            return mediaQuery.split(",").map(function(query) {
		                query = query.trim();
		                var captures = query.match(RE_MEDIA_QUERY), modifier = captures[1], type = captures[2], expressions = captures[3] || "", parsed = {};
		                return parsed.inverse = !!modifier && "not" === modifier.toLowerCase(), parsed.type = type ? type.toLowerCase() : "all", 
		                expressions = expressions.match(/\([^\)]+\)/g) || [], parsed.expressions = expressions.map(function(expression) {
		                    var captures = expression.match(RE_MQ_EXPRESSION), feature = captures[1].toLowerCase().match(RE_MQ_FEATURE);
		                    return {
		                        modifier: feature[1],
		                        feature: feature[2],
		                        value: captures[2]
		                    };
		                }), parsed;
		            });
		        }
		        function toDecimal(ratio) {
		            var numbers, decimal = Number(ratio);
		            return decimal || (numbers = ratio.match(/^(\d+)\s*\/\s*(\d+)$/), decimal = numbers[1] / numbers[2]), 
		            decimal;
		        }
		        function toDpi(resolution) {
		            var value = parseFloat(resolution);
		            switch (String(resolution).match(RE_RESOLUTION_UNIT)[1]) {
		              case "dpcm":
		                return value / 2.54;

		              case "dppx":
		                return 96 * value;

		              default:
		                return value;
		            }
		        }
		        function toPx(length) {
		            var value = parseFloat(length);
		            switch (String(length).match(RE_LENGTH_UNIT)[1]) {
		              case "em":
		              case "rem":
		                return 16 * value;

		              case "cm":
		                return 96 * value / 2.54;

		              case "mm":
		                return 96 * value / 2.54 / 10;

		              case "in":
		                return 96 * value;

		              case "pt":
		                return 72 * value;

		              case "pc":
		                return 72 * value / 12;

		              default:
		                return value;
		            }
		        }
		        exports.match = matchQuery, exports.parse = parseQuery;
		        var RE_MEDIA_QUERY = /(?:(only|not)?\s*([^\s\(\)]+)(?:\s*and)?\s*)?(.+)?/i, RE_MQ_EXPRESSION = /\(\s*([^\s\:\)]+)\s*(?:\:\s*([^\s\)]+))?\s*\)/, RE_MQ_FEATURE = /^(?:(min|max)-)?(.+)/, RE_LENGTH_UNIT = /(em|rem|px|cm|mm|in|pt|pc)?$/, RE_RESOLUTION_UNIT = /(dpi|dpcm|dppx)?$/;
		    }, function(module, exports, __webpack_require__) {
		        function _interopRequireDefault(obj) {
		            return obj && obj.__esModule ? obj : {
		                default: obj
		            };
		        }
		        function keyVal(k, v) {
		            var realKey = (0, _hyphenateStyleName2.default)(k);
		            return "number" == typeof v && (v += "px"), true === v ? k : false === v ? negate(k) : "(" + realKey + ": " + v + ")";
		        }
		        function join(conds) {
		            return conds.join(" and ");
		        }
		        Object.defineProperty(exports, "__esModule", {
		            value: true
		        }), exports.default = function(obj) {
		            var rules = [];
		            return Object.keys(_mediaQuery2.default.all).forEach(function(k) {
		                var v = obj[k];
		                null != v && rules.push(keyVal(k, v));
		            }), join(rules);
		        };
		        var _hyphenateStyleName = __webpack_require__(5), _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName), _mediaQuery = __webpack_require__(6), _mediaQuery2 = _interopRequireDefault(_mediaQuery), negate = function(cond) {
		            return "not " + cond;
		        };
		        module.exports = exports.default;
		    } ]);
		});
		
	} (reactResponsive$1));
	return reactResponsive$1.exports;
}

export { requireReactResponsive as __require };
